// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomAmplifyAuthenticator_container__MkwRh"};